/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷可能フラグ（土曜日）
 * @export
 * @interface EnableShipdaySat
 */
export interface EnableShipdaySat {
}

/**
 * Check if a given object implements the EnableShipdaySat interface.
 */
export function instanceOfEnableShipdaySat(value: object): value is EnableShipdaySat {
    return true;
}

export function EnableShipdaySatFromJSON(json: any): EnableShipdaySat {
    return EnableShipdaySatFromJSONTyped(json, false);
}

export function EnableShipdaySatFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnableShipdaySat {
    return json;
}

export function EnableShipdaySatToJSON(json: any): EnableShipdaySat {
    return EnableShipdaySatToJSONTyped(json, false);
}

export function EnableShipdaySatToJSONTyped(value?: EnableShipdaySat | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

